import React, { Component } from "react"
import { Link, withRouter } from "react-router-dom"
import getMenus from "../constants/menu.export"
// import AuthModal from '../models/authModal'
// import { useSetState } from "ahooks"
// import Env from "../util/env"
import fullScreen from "../util/fullScreen"
import gridTitleLogo from "../img/grid-title.png"
const windowWidgetMap = [
  {
    name: "返回",
    icon: require("../img/grid-back.png"),
  },
  {
    name: "刷新",
    icon: require("../img/grid-refresh.png"),
  },
  {
    name: "全屏",
    icon: require("../img/grid-all.png"),
  },
]

function renderMenu(menu, curPath) {
  if (!menu.id) {
    return null
  }
  if (menu.path) {
    return (
      <Link className={menu.path === curPath ? "active" : ""} to={menu.path}>
        <span>{menu.name}</span>
      </Link>
    )
  } else {
    return <span>{menu.name}</span>
  }
}

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menuList: [],
    }
  }
  static getDerivedStateFromProps() {
    return {
      menuList: getMenus(),
    }
  }
  componentDidMount() {
    fullScreen.init()
  }

  getChildTree(menuList, curPath) {
    if (!menuList) {
      return null
    }
    return (
      <div className="nav-subs">
        {menuList.map((item, i) => {
          return (
            <div key={i} className="nav-sub">
              {renderMenu(item, curPath)}
            </div>
          )
        })}
      </div>
    )
  }

  handleWindow = (params) => {
    console.log(params)
    if (params === 0) {
      fullScreen.closePage()
    }
    if (params === 1) {
      window.location.reload()
    }
    if (params === 2) {
      fullScreen.enterFullScreen()
    }
  }

  render() {
    let { menuList } = this.state
    let curPath = this.props.location.pathname
    return (
      <div
        className={"pg-header " + (curPath === "/grid" ? "pg-header-grid" : "")}
      >
        <span className="logo">
          <img src={gridTitleLogo} alt="gridTitleLogo" />
        </span>
        <div className="windowWidget">
          {windowWidgetMap.map((item, index) => {
            return (
              <div
                className={`widget-${index} widget`}
                key={index}
                onClick={() => {
                  this.handleWindow(index)
                }}
              >
                {item.name}
              </div>
            )
          })}
        </div>
        <div
          className="close-div"
          onClick={() => {
            this.handleWindow(0)
          }}
        >
          X
        </div>
        {/* <ul className="nav">
          {menuList.map((item, i) => {
            let childrenObj = item.children
            let active = item.path === curPath
            if (childrenObj) {
              active = childrenObj.some((m) => {
                return m.path === curPath
              })
            }

            return (
              <li key={i} className={"nav-item" + (active ? " active" : "")}>
                {renderMenu(item, curPath)}
                {this.getChildTree(childrenObj, curPath)}
              </li>
            )
          })}
        </ul> */}
      </div>
    )
  }
}

export default withRouter(Header)
